import React, {useState} from "react";
import {ButtonGroup, ButtonGroupButton, DatePicker, Icon} from "peggirkit";
import {CalendarDaysIcon, ClockIcon} from "@heroicons/react/20/solid";
import {FormattedMessage, useIntl} from "react-intl";
import {usePos} from "@/context/pos/PosProvider";
import {fromLocalDateString, isToday, toLocalDateString} from "@/utils/DateUtils";


const DateFilter = () => {
    const intl = useIntl();
    const {selectedDay, setSelectedDay} = usePos();
    const [showDayPicker, setShowDayPicker] = useState(false);
    const isTodaySelected = selectedDay === null;

    return (
        <>
            <ButtonGroup variant={"outline"}>
                <ButtonGroupButton
                    iconBefore={<Icon icon={ClockIcon}/>}
                    buttonAction={{
                        as: "button",
                        actionProps: {
                            onClick: () => setSelectedDay(null),
                        },
                    }}
                    selected={isTodaySelected}
                >
                    <FormattedMessage id={"today"}/>
                </ButtonGroupButton>
                <ButtonGroupButton
                    iconBefore={<Icon icon={CalendarDaysIcon}/>}
                    buttonAction={{
                        as: "button",
                        actionProps: {
                            onClick: () => setShowDayPicker(true),
                        },
                    }}
                    selected={!isTodaySelected}
                >
                    {
                        selectedDay || <FormattedMessage id={"pick-day"}/>
                    }
                </ButtonGroupButton>
            </ButtonGroup>

            <DatePicker
                title={intl.formatMessage({id: "pickADay"})}
                show={showDayPicker}
                setShow={setShowDayPicker}
                continueButton={{
                    text: intl.formatMessage({id: "apply"}),
                }}
                cancelButton={{
                    text: intl.formatMessage({id: "cancel"}),
                }}
                pickerConfig={{
                    type: "single",
                    defaultDay: selectedDay === null ? new Date() : fromLocalDateString(selectedDay),
                    onContinue: (selectedDate: Date | undefined) => {
                        if (selectedDate === undefined)
                            return;

                        // Picking today behaves like the "Today" button
                        setSelectedDay(isToday(selectedDate) ? null : toLocalDateString(selectedDate));
                    },
                }}
            />
        </>
    );
};

export default DateFilter;